




























import Vue from 'vue'
import EventCard from '@/components/Event/Card'
import Presenter, { IPresenter } from './presenter'
import { IEventThumbnail } from '@/types/domain/event'
import { isDOMAccessible } from '@/utils/dom'
import SchoolEntity from '@/entities/School'
import EventEntity from '@/entities/Event'
import FetchEventThumbnailsUseCase from '@/usecases/event/FetchEventThumbnailsUseCase'

interface IData {
  isPositionTop: boolean
  windowInnerHeightHalf: number
}

export default Vue.extend({
  components: {
    EventCard
  },
  props: {
    groupId: {
      type: Number,
      required: true
    },
    eventId: {
      type: Number,
      required: true
    }
  },
  data(): IData {
    return {
      isPositionTop: false,
      windowInnerHeightHalf: 0
    }
  },
  computed: {
    presenter(): IPresenter {
      return Presenter({
        groupRepository: this.$groupRepository,
        groupId: this.$props.groupId,
        metaRepository: this.$metaRepository,
        eventRepository: this.$eventRepository,
        profileRepository: this.$profileRepository
      })
    }
  },
  async mounted() {
    /* 必要なサムネイルのみ取得 (最大2件) */
    const fetchEventThumbnailsUseCase = new FetchEventThumbnailsUseCase({
      snapsnapGateway: this.$snapsnapGateway,
      eventRepository: this.$eventRepository
    })
    let targetEventIds: number[] = []
    const filterdCurrentEvents = this.sortedEvents()
    if (filterdCurrentEvents) {
      targetEventIds = filterdCurrentEvents.map((m: { data: EventEntity; school: SchoolEntity }) => {
        return m.data.props.id
      })
    }
    await fetchEventThumbnailsUseCase.execute({ eventIds: targetEventIds })

    /* scrollイベントの登録 */
    if (filterdCurrentEvents) {
      this.windowInnerHeightHalf = window.innerHeight / 2
      window.addEventListener('scroll', this.handleScroll)

      /* 初期表示時に一度実行 */
      this.handleScroll()

      /* 「他のイベントをみる」の配置を他の掲載中のイベントに合わせる */
      this.initParentFuncAdjustLinkPosition(true)
    } else {
      /* 「他のイベントをみる」の配置を他の掲載中のイベントに合わせず中央配置にする */
      this.initParentFuncAdjustLinkPosition(false)
    }
  },
  destroyed() {
    /* scrollイベントの削除 */
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      /* 他の掲載中のイベントの上辺が画面の中心より上にきた場合 Other Events (タイトル) の位置を変更する
         (上辺が画面の中心より下にきた場合も同様にタイトルの位置を変更) */
      if (!isDOMAccessible()) return
      const $target = this.$refs.target as Element
      if ($target.getBoundingClientRect().top > this.windowInnerHeightHalf) {
        this.isPositionTop = false
      } else {
        this.isPositionTop = true
      }
    },
    hidePositionTop() {
      this.isPositionTop = false
    },
    hidePositionBottom() {
      this.isPositionTop = true
    },
    sortedEvents() {
      /* 取得した掲載中のイベントから現在のeventIdを除外 */
      const filterdEvents = this.presenter.currentEventOfPublished.filter((event: { data: EventEntity; school: SchoolEntity }) => {
        return event.data.props.id !== this.$props.eventId
      })
      if (!filterdEvents.length) {
        return null
      }
      /* 掲載期限が近いものから2件取得 */
      return filterdEvents.sort((x, y) => x.data.orderEndDtUnixtime - y.data.orderEndDtUnixtime).slice(0, 2)
    },
    getEventThumbnails(eventId: number): Pick<IEventThumbnail, 'uchinokoUrls' | 'albumPhotoUrls'> | undefined {
      const data = this.presenter.eventThumbnails[eventId]
      return data
    },
    /* 親Componentにある他の「他のイベントをみる」のリンクの配置を変更 */
    initParentFuncAdjustLinkPosition(bool: boolean) {
      this.$emit('change', bool)
    }
  }
})
